// extracted by mini-css-extract-plugin
export default {"zoomModal":"C3-z"};